import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "company-info-form" }
const _hoisted_2 = { class: "sm:rounded-md" }
const _hoisted_3 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_4 = { class: "col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "company-name",
  class: "onboarding-label"
}, "Company Name", -1)
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Company Size", -1)
const _hoisted_9 = { class: "w-72" }
const _hoisted_10 = { class: "relative mt-1" }
const _hoisted_11 = { class: "block truncate" }
const _hoisted_12 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_13 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = { class: "flex flex-row mt-4 items-baseline" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_ReCaptchaV2 = _resolveComponent("ReCaptchaV2")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.companyInfoSubmitted && _ctx.companyInfoSubmitted(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "company-name",
              id: "company-name",
              autocomplete: "organization",
              class: "text-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event))
            }, null, 512), [
              [_vModelText, _ctx.v$.name.$model]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.name.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Listbox, {
                modelValue: _ctx.selectedBracket,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBracket) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ListboxButton, { class: "relative w-full py-2 pl-3 pr-10 text-left rounded-md cursor-default sm:text-sm border-gray-500 border-2" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedBracket.title), 1),
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_SelectorIcon, {
                            class: "w-5 h-5 text-gray-500",
                            "aria-hidden": "true"
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_Transition, {
                      "leave-active-class": "transition duration-100 ease-in",
                      "leave-from-class": "opacity-100",
                      "leave-to-class": "opacity=0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ListboxOptions, { class: "absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeBrackets, (size) => {
                              return (_openBlock(), _createBlock(_component_ListboxOption, {
                                key: size.id,
                                value: size,
                                as: "template"
                              }, {
                                default: _withCtx(({ active, selected }) => [
                                  _createElementVNode("li", {
                                    class: _normalizeClass([
                                                    active
                                                        ? 'text-white bg-teal'
                                                        : 'text-gray-900',
                                                    'cursor-default select-none relative py-2 pl-10 pr-4',
                                                ])
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([
                                                        selected
                                                            ? 'font-medium'
                                                            : 'font-normal',
                                                        'block truncate',
                                                    ])
                                    }, _toDisplayString(size.title), 3),
                                    selected
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                          _createVNode(_component_CheckIcon, {
                                            class: "w-5 h-5",
                                            "aria-hidden": "true"
                                          })
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode(_component_ReCaptchaV2, {
          class: "pt-5",
          onToken: _ctx.tokenReceived
        }, null, 8, ["onToken"]),
        (_ctx.responseError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.responseError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, [
            _createVNode(_component_LoadingButton, {
              disabled: _ctx.v$.$invalid || _ctx.loading,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Company Information ")
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ])
      ])
    ], 32)
  ]))
}